import * as routesNames from '../routes/routeName'

/**
 * The pages a user can only reach BECAUSE they are an admin — i.e. the ones
 * whose nav entries are already gated on `adminModule === 1` in
 * workspaceTabs.js, sidebar.js and header.js.
 *
 * While admin screen privacy is on (F9 x5, see useAdminStealth) those entries
 * stop being drawn, so this list is what the redirect uses to close the
 * matching hole: a hidden admin who types one of these addresses, or follows
 * an old bookmark, lands on the dashboard instead of a page that is supposed
 * to be out of sight.
 *
 * DELIBERATELY NOT LISTED — pharmacy_settings. The WINRX sidebar entry points
 * at `${pharmacy_settings}?active=mistmatch_delivery`, but Settings itself is
 * not an admin-only page: normal users open it every day. Redirecting the
 * whole route to hide one tab would take away access people already have,
 * which is the one thing this feature must never do. The entry still
 * disappears from the sidebar.
 *
 * This is a VISIBILITY list, not a permission list. Everything here is still
 * fully authorised for the user; the backend is unchanged and remains the only
 * thing deciding what they may actually do.
 */
export const ADMIN_ONLY_ROUTES = [
	// Pharmacist-only (type === 'pharmacist'). A role entry like the admin
	// ones below, so it hides — and redirects — with them.
	routesNames.pharmacy_driver_clinic_call_logs,

	// TEAM tab (constants/workspace.js -> TeamItems) and the screens it opens.
	routesNames.pharmacy_user,
	routesNames.pharmacy_timeoff,
	routesNames.pharmacy_team_attendance,
	routesNames.pharmacy_certificate_template,
	routesNames.pharmacy_assign_certificate,
	routesNames.pharmacy_assign_certificate_employee,
	routesNames.pharmacy_check_out_in,
	routesNames.pharmacy_department,
	routesNames.pharmacy_team_avalibility,
	routesNames.pharmacy_tasks_list,

	// Sidebar "STAT Holidays" (adminModule === 0 hides it today).
	routesNames.pharmacy_holidays_calander,

	// Dispense entries that require adminModule === 1 today.
	routesNames.pharmacy_super_nova_verification,
	routesNames.pharmacy_half_baked,

	// Dispense "Delivery Drivers" (adminModule === 0 hides it today).
	routesNames.pharmacy_driver,

	// Packaging "Invoice" / "Monthly Invoice" (adminModule === 0 hides them).
	routesNames.pharmacy_blister_packaging_invoices,
	routesNames.pharmacy_blister_packaging_monthly_invoice,
	routesNames.pharmacy_packaging_invoices,
	routesNames.pharmacy_packaging_monthly_invoice,
]

/**
 * Is this pathname one of the admin-only pages?
 *
 * Compares the PATH only, so a query string (`?active=...`) or a trailing
 * slash still matches, and a nested detail page under one of these sections
 * (e.g. an id appended to it) matches its parent.
 */
export const isAdminOnlyRoute = (pathname) => {
	if (!pathname) return false

	const path = String(pathname).split('?')[0].replace(/\/+$/, '')
	if (!path) return false

	return ADMIN_ONLY_ROUTES.some((route) => {
		if (!route) return false
		const base = String(route).split('?')[0].replace(/\/+$/, '')
		if (!base) return false
		return path === base || path.startsWith(`${base}/`)
	})
}

export default ADMIN_ONLY_ROUTES
